// Whether an office's clients are collected from by the AFFILIATE rather than by us.
//
// It is the one switch that turns the whole path on: enrolment may then finish with no bank account
// and no card, creating an 'Affiliate' billing method instead. A payment on that method waits for
// someone to mark it paid. A bank account on file is still charged; a card only when the office
// leaves cards to us (affiliateCollectsCards below).
//
// Strictly true, never truthy.

export const isAffiliateBilledOffice = (customSettings) => customSettings?.affiliateBilled === true

// WS #2453778 (Modern Financial): in an affiliate-billed office, does the affiliate collect the CARDS
// too? Absent reads as yes, the behaviour every office had before the setting existed (PACK charges
// its clients' cards itself). Only a real false means we charge the cards, as we do bank accounts.
export const AFFILIATE_COLLECTS_CARDS_FLAG = 'AFFILIATE_COLLECTS_CARDS_SETTING'

export const affiliateCollectsCards = (customSettings) => customSettings?.affiliateCollectsCards !== false
